<template lang="pug">
  #ContactsIndex
    .content-header.bg-secondary.rounded-bottom-1rem.d-flex.align-items-center
      h5.mb-0 我的顧客
    .container-width
      .p-3
        i.fas.fa-users.mb-3.pr-1
        span.text-danger.pr-1.font-weight-bold {{ filterMoney(pagination.total) }}
        | 位

        b-card.border-0.mb-1.customerCard.overflow-hidden(
          bg-variant="white",
          v-for="(user,index) in memberList",
          :key="user.member_id",
          @click="showUserInfoHandler(user.member_id)",
          body-class="p-0"
        )
          .row
            .col-2.d-flex.align-items-center.justify-content-center(
              v-show="selectMode"
            )
              b-form-checkbox(
                :id="`checkbox-group-${index}`",
                v-model="selectUsers",
                :name="`user-${index}`",
                :value="user",
                v-show="selectMode"
              )
            div(
              :class="{ 'col-10': selectMode, 'col-12': !selectMode }"
            )
              label.w-100.mb-0(
                :for="`checkbox-group-${index}`"
              )
                .row.align-items-center.mb-2.pb-2.no-gutters(
                  :class="{ 'border-bottom border-black': index + 1 !== memberList.length }"
                )
                  .col-3.pr-1
                    ProfilePhotoSticker.ProfilePhotoSticker.d-flex.align-items-center.justify-content-center.border.border-black(
                      :profileUrl="user.picture_url",
                      :style="{ 'width': '60px', 'height': '60px' }"
                    )
                  .col-9.pl-1
                    p.mb-0.font-weight-bold {{ user.line_display_name }}
                    p.mb-0.text-gray {{ user.note_name ? user.note_name : '-' }}
</template>

<script>
import { mapState } from 'vuex';
import ProfilePhotoSticker from '@/components/profilePhotoSticker/ProfilePhotoStickerComponent.vue';
import { SA_MY_CUSTOMER_INDEX } from '@/router/sa/my-customer';

export default {
  name: 'ContactsIndex',
  components: {
    ProfilePhotoSticker
  },
  data() {
    return {
      searchInput: {
        chinese_last_name: null,
        code: null,
        card_type: null,
        birthday: null
      },
      selectMode: false,
      selectUsers: []
    };
  },
  created() {
    const vm = this;
    vm.$store.commit('toggleLoading', false);
    vm.$store.commit('sa_contacts/resetHandler');
    vm.infiniteHandler();
  },
  methods: {
    infiniteHandler() {
      const vm = this;
        vm.$swal.fire({
        title: '載入中，請稍候',
        allowOutsideClick: false,
        willOpen: () => {
          this.$swal.showLoading();
        }
      });
      vm.$store.dispatch('sa_contacts/getMemberListHandler', {
        chinese_last_name: null,
        code: null,
        card_type: null,
        birthday: null
      })
        .then(() => {
          vm.$swal.close();
        });
    },
    showUserInfoHandler(userId) {
      const vm = this;
      if (vm.selectMode) return;
      vm.$router.push({
        name: SA_MY_CUSTOMER_INDEX,
        params: {
          userId
        }
      }).catch(() => {});
    }
  },
  computed: {
    ...mapState({
      memberList: (state) => state.sa_contacts.memberList,
      pagination: (state) => state.sa_contacts.pagination
    })
  },
  beforeRouteLeave(to, from, next) {
    const vm = this;
    vm.$store.commit('sa_contacts/resetHandler');
    next();
  }
};
</script>

<style lang="scss" scoped>
.searchArea {
  &__iconArrow {
    position: absolute;
    right: 10px;
    top: 5px;
    outline: none;
    transform: rotate(0deg);
    transition: all .3s;
  }
  &__iconArrow.collapsed {
    transform: rotate(180deg);
  }
}

.ProfilePhotoSticker {
  border: 0.2rem solid #000!important;
}
</style>
